import React, { ReactElement } from 'react';
import { Translate } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RATTACHEMENT_DEMANDE } from '../../../routes';

type Props = RouteComponentProps &{
  nbPendingDemands: number,
};

function RattachmentBouton(props: Props): ReactElement {
  return (
    <button
      type="button"
      className="button fourth rattachement-bouton"
      onClick={() => props.history.push(RATTACHEMENT_DEMANDE)}
    >
      <div className="rattachment-btn-content">
        {props.nbPendingDemands > 0
      && (
      <div className="pending-demands-indicator">
        {props.nbPendingDemands}
      </div>
      )}
        <Translate value="HEADER.RATTACHEMENT_DEMAND" />
      </div>
    </button>
  );
}
export default withRouter(RattachmentBouton);
